import React from 'react';
import { Modal, Button, ListGroup, Row, Col, Nav, Tab, Card } from 'react-bootstrap';
import { User } from '../../interface';
import userDefault from '../../Assets/images/user.png'
import arrowlogout from '../../Assets/images/arrow-logout.svg'
import textlogout from '../../Assets/images/Log-Out.svg'
import { useOktaAuth } from '@okta/okta-react';
import { Link } from 'react-router-dom';
interface Subscription {

  applicationName: string;
  renewalDate: string;
}

interface UserProfileModalProps {
  showModal: boolean;
  handleModal: () => void;
  handleModalContact: () => void;
  userProfile?: User;
}

const UserProfileModal: React.FC<UserProfileModalProps> = ({ showModal, handleModal, userProfile, handleModalContact }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const logout = async () => oktaAuth.signOut();
  return (
    <Modal show={showModal} onHide={handleModal} size="xl" centered >

      <Modal.Body className='py-0 min-h-500'>
        <div className="close-modal">
          <Button variant="close" onClick={handleModal}></Button>
        </div>
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <Row className='min-h-500'>
            <Col className='bg-8 pt-4 px-5 position-relative' md={4}>
              <div className="d-flex align-items-center flex-column  mb-3">
                <div className='border-bottom w-100 d-flex align-items-center flex-column mb-5'>
                  <div className="">
                    <img
                      src={userDefault}
                      alt="User"
                      className="rounded-circle"
                    />
                  </div>
                  <div className='text-center'>
                    <h5>{userProfile?.user_firstname}</h5>
                    {/* <p className="mb-0">{userProfile?.user_email}</p> */}
                  </div>
                </div>

                <Nav variant="pills" className="flex-column nav-pills-custom">
                  <Nav.Item>
                    <Nav.Link eventKey="first">Personal Information</Nav.Link>
                  </Nav.Item>
                  {/* <Nav.Item>
                    <Nav.Link eventKey="second">Subscriptions</Nav.Link>
                  </Nav.Item> */}
                  <Nav.Item>
                    <Link className="nav-link" to='https://grayassociates.oktapreview.com/signin/forgot-password' target='_blank'>Reset Password</Link>
                  </Nav.Item>
                </Nav>


              </div>
              <div className="logout position-absolute d-flex align-items-center justify-content-center  cursor-pointer" onClick={logout}>
                <img src={arrowlogout} alt="" className='me-1' />
                <img src={textlogout} alt="" />

              </div>
            </Col>
            <Col md={8} className='shadow-l h-full pt-4 px-5'>

              <Tab.Content>
                <Tab.Pane eventKey="first">

                  <div className='d-flex pb-3'>
                    <h5 className='card-title'>Personal Information</h5>
                  </div>
                  <Card style={{ width: '100%' }} className='mb-5 card-border'>
                    <Card.Body>
                      <Row>
                        <Col md={6} className='mb-3'>
                          <div className='card-subtitle'>First Name</div>
                          <div>{userProfile?.user_firstname}</div>
                        </Col>
                        <Col md={6} className='mb-3'>
                          <div className='card-subtitle'>Last Name</div>
                          <div>{userProfile?.user_lastname}</div>
                        </Col>
                        {/* <Col md={4} className='mb-3'>
                          <div className='card-subtitle'>State/Region</div>
                          <div>{userProfile?.user_department}</div>
                        </Col> */}
                        <Col md={6} className='mb-3'>
                          <div className='card-subtitle'>Phone Number</div>
                          <div>{userProfile?.user_phoneNbr}</div>
                        </Col>
                        <Col md={6} className='mb-3'>
                          <div className='card-subtitle'>Mail</div>
                          <div>{userProfile?.user_email}</div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                  <div className='d-flex pb-3'>
                    <h5 className='card-title'>Job/Position Details</h5>
                  </div>
                  <Card style={{ width: '100%' }} className='card-border'>
                    <Card.Body>
                      <Row>
                        <Col>
                          <div className='card-subtitle'>Job/Position</div>
                          <div>{userProfile?.user_department}</div>
                        </Col>
                        <Col>
                          <div className='card-subtitle'>College/University</div>
                          <div>{userProfile?.account.institution_name}</div>
                        </Col>

                      </Row>
                    </Card.Body>
                  </Card>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <div className='d-flex align-items-center '>
                    <h5>Subscriptions</h5>

                  </div>
                  <table className='w-100'>
                    <thead>
                      <tr className='border-bottom'>
                        <th>Subscription</th>
                        <th className='text-end font-bold'>Renewal Date</th>
                      </tr>
                    </thead>
                  </table>

                  <div className="text-center mt-3 bg-8">
                    <p>Do you want to cancel or acquire a subscription?</p>
                    <Button variant="primary" onClick={() => handleModalContact()}>Contact Sales</Button>
                  </div></Tab.Pane>
              </Tab.Content>

            </Col>
          </Row>
        </Tab.Container>

      </Modal.Body>
    </Modal>
  );
};

export default UserProfileModal;
